<template>
  <v-flex wrap class="container">
    <v-layout column>
      <text-field
        v-model="form.title"
        :validator="vs.title"
        :label="adminText('workflowsAll.title_768e0c1', 'Title')"
      />
      <textarea-field
        v-model="form.titleDescription"
        :validator="vs.titleDescription"
        :label="adminText('workflowsAll.description_55f8ebc', 'Description')"
      />
    </v-layout>
    <v-layout v-if="hasCategories" column>
      <text-field
        v-model="form.form.category"
        :validator="vs.form.category"
        :label="adminText('workflowsAll.category_a3c686e', 'Category')"
      />
      <text-field
        v-model="form.form.zones"
        :validator="vs.form.zones"
        :label="adminText('workflowsAll.zones_182e2eb', 'Zones')"
      />
    </v-layout>
  </v-flex>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'register-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    hasCategories: {
      type: Boolean,
      default: () => false,
    },
    hasWorkshops: {
      type: Boolean,
      default: () => false,
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        title: 'Register',
        titleDescription: 'Here you can provide information that is going to be used to create your accreditation at the event.',
        form: {
          firstName: 'First name',
          lastName: 'Last name',
          category: 'Category',
          zones: 'Zones',
        },
      },
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  mounted () {
    if(this.initialValues && Object.keys(this.initialValues).length) {
      const internalForm = this.initialValues.form ? {...this.form.form, ...this.initialValues.form} : this.form.form
      this.form = {...this.form, ...this.initialValues, form: {...internalForm}}
    }
    this.$emit('values', this.form)
  },
}
</script>

<style scoped>
  .container {
    max-width: 672px !important;
    margin: 0;
    padding-left: 0;
    padding-right: 0;
  }

  >>>.v-input__slot {
    justify-content: center;
  }

</style>
